import {
  UseFormReturnType,
  Validator,
  globalMessageHandler,
  loadMultipleOptions,
  useForm,
} from "common";
import { useParams } from "common/components/Form/ParamsContext";
import { getPartnerService } from "features/partners/partnerApi";
import { getRoleService } from "features/roles/roleApi";
import I18n from "i18n";
import { Params } from "react-router-dom";
import { UserItem, UserOptions, getUserService } from "./userApi";

type RouteParams = {
  user_id?: string;
};

export interface UseUserFormReturnType extends UseFormReturnType<
  UserItem,
  UserOptions
> {
  params?: Readonly<Params<"user_id">>;
}

export interface UseUserFormProps {}

export default function useUserForm({}: UseUserFormProps): UseUserFormReturnType {
  const params = useParams<"user_id">();
  const scope = undefined;
  const service = getUserService(scope);

  const form = useForm<UserItem, UserOptions>({
    id: params.user_id,
    translationCategory: "User",
    rules: {
      first_name: Validator.rule.string().required(),
      //last_name: Validator.rule.string().required(),
      email: Validator.rule.string().required(),
      role_ids: Validator.rule.any().required(),
    },
    onValidationFailed: () => {
      globalMessageHandler.snack({
        severity: "error",
        message: I18n.t("App.formHasErrors"),
      });
    },
    ...service,
    loadOptions: loadMultipleOptions({
      role_ids: () => getRoleService().loadAutocomplete(),
      partner_id: () => getPartnerService().loadAutocomplete(),
    }),
    transformChange: (item, id, option, oldItem) => {
      console.log({ id, option });
      let newItem = Object.assign({}, item);
      if (id === "partner_id") {
        if (!!item.partner_id) {
          newItem.first_name = option?.label || option?.name || "";
          newItem.last_name = null;
        }
      }

      return newItem;
    },
  });

  let rules: any = {};

  if (form.item?.role_ids?.includes(14)) {
    // 14 = ROLE_PARTNER_ADMIN
    rules.partner_id = Validator.rule.any().required();
  }
  if (!form.item?.partner_id) {
    rules.last_name = Validator.rule.any().required();
  }
  form.addRules(rules);

  return { ...form, params };
}
